import { DataBean } from "../DataBean";

export class MatrixImportNationalization extends DataBean {


    public async getMatrixImportNationalizationReport(page:any,rows:any,Map:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "com.advantage.shared.Report_getMatrixImportNationalizationReport_Number_Number_java.util.Map", [page,rows,Map]);
    }
    public async deleteNationalizationProcessGeneralInfo(id:number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "boolean_deleteNationalizationProcessGeneralInfo_Number", [id]);
    }



 
}